import React from "react";
import Modal from "../../../components/Modal";

import LoadingComponent from "./lazy";

export default props => (
    <Modal width={680}>
        <LoadingComponent {...props} />
    </Modal>
);
